/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { get, put, post, del } from 'common/services/ApiService';
import { RegisteredContractor, RegistrationFilterQuery } from 'common/types';

const baseUrl = 'contractors/registrations';

export interface DirectSupplyAccountManager {
    id: number;
    name: string;
    motiliRep?: {
        id: number;
        firstName: string;
        lastName: string;
    };
}

export function getRegistrations(filterQuery: RegistrationFilterQuery) {
    return get(true, baseUrl, { filter: filterQuery });
}

export function getDirectSupplyAccountManagers(): Promise<
    DirectSupplyAccountManager[]
> {
    return get(true, 'Clients/directSupplyAccountManagers', undefined, false);
}

export function getRegistrationsCount(filterQuery: RegistrationFilterQuery) {
    return get(true, `${baseUrl}/count`, { filter: filterQuery });
}

export function getRegistrationById(
    id: string,
    filterQuery: RegistrationFilterQuery
) {
    return get(true, `${baseUrl}/${id}`, { filter: filterQuery });
}

export function deleteRegistrationFileUpload(id: string, key: string) {
    return del(`${baseUrl}/${id}/${encodeURIComponent(key)}`);
}

export function rejectRegistration(id: string, reason: string) {
    return post(true, `${baseUrl}/${id}/reject`, { reason });
}

export function updateRegistration(
    id: string,
    body: Partial<RegisteredContractor>
) {
    return put(true, `${baseUrl}/${id}`, body);
}

export function getSignedPdf(
    uuid: string,
    signature_request_id: string,
    template_id: string
) {
    return post(false, `eSignature/uploadSignedDocument`, {
        uuid,
        signature_request_id,
        template_id,
    });
}

export function requestSignature(
    template_id: string,
    email_address: string,
    name: string,
    custom_fields?: { name: string; value: string }[]
) {
    return post(false, `eSignature/signatureRequest`, {
        template_id,
        email_address,
        name,
        ...(custom_fields && { custom_fields }),
    });
}

export function checkSignatureStatus(signature_request_id: string) {
    return get(
        false,
        `eSignature/signatureRequest?signature_request_id=${signature_request_id}`
    );
}

export function fetchSavedAgreementTemplates() {
    return get(false, `eSignature/agreementTemplates`);
}
